import enums from '@/helpers/enums';

// Deep links into the Template Designer SPA.
//
// It owns the whole template pipeline — the design-group tree, the brand library, batch generation — so
// screens here report shortfalls and link out to it rather than generating anything themselves. One copy of
// the URL shape, mirroring Core's TemplateDesignerUrl helper (which builds the same links server-side, for
// the gap fixes and the Needs Generation grid).
//
// It sits on its own subdomain behind a HASH router, so the query lives after the '#'. StudioMain.vue reads
// it on mount and then strips it.

export const TEMPLATES_TAB = 'templates';
export const BRANDS_TAB = 'brands';

function host() {
  return (process.env.VUE_APP_TEMPLATE_DESIGNER_URL || '').replace(/\/+$/, '');
}

// 'templates' is the default tab over there, so it never needs saying.
function tabPart(tab) {
  return !tab || tab === TEMPLATES_TAB ? '' : `&tab=${tab}`;
}

/** An industry's workspace. */
export function industryUrl(industryId, tab) {
  return `${host()}/#/?industryId=${industryId}${tabPart(tab)}`;
}

/** A topic's workspace. The Studio back-fills the parent industry itself, so the topic id is enough. */
export function topicUrl(topicId, tab) {
  return `${host()}/#/?topicId=${topicId}${tabPart(tab)}`;
}

/** A category's workspace. */
export function categoryUrl(categoryId) {
  return `${host()}/#/?categoryId=${categoryId}`;
}

/**
 * The workspace for one audience — an Industry or a Topic, addressed the way campaign targets are.
 * Returns null for a target type that has no workspace over there (Category, ContentPage).
 */
export function audienceUrl(targetType, targetId, tab) {
  if (!targetId) return null;
  if (targetType === enums.AUDIENCE.TYPE.INDUSTRY) return industryUrl(targetId, tab);
  if (targetType === enums.AUDIENCE.TYPE.TOPIC) return topicUrl(targetId, tab);
  return null;
}
